// extracted by mini-css-extract-plugin
export default {"Environments":"Environments_Environments__COPAr","ActionButton":"Environments_ActionButton__a-Ejj","TabContents":"Environments_TabContents__Npm+6"};